// extracted by mini-css-extract-plugin
export default {"row":"DishesTable_row__0qCmz","placeHolderShimmer":"DishesTable_placeHolderShimmer__MPFPC"};